export enum ContactType {
  LEAD = "LEAD",
  CONTACT = "CONTACT",
  ACCOUNT = "ACCOUNT",
  OPPORTUNITY = "OPPORTUNITY",
}
